import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../auth/services/auth.service';
import { catchError, map, Observable, of } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class LockerLiteGuard  {
    constructor(
        private router: Router,
        private authService: AuthService
    ) {
    }

        canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
            if (state.url) {
                const urlTree = this.router.parseUrl(state.url || '');
                const code = urlTree.queryParamMap.get('code');

                if (code) {
                    return this.authService.getB2CTokens(code).pipe(
                        map(() => {
                            return this.handleAuthorized(state);
                        }),
                        catchError(() => {
                            return of(false);
                        })
                    );
                }
            }

            return this.handleAuthorized(state);
        }

    private handleAuthorized(state: RouterStateSnapshot): boolean {
        if (this.authService.isAuthenticated()) {
            return true;
        } else {
            // if coming from mobile app to change password
            if (state.url.endsWith('password-reset')) {
                this.router.navigate(['password-reset'], {
                    queryParams: { returnUrl: state.url },
                    queryParamsHandling: 'merge'
                });
                return true;
            }

            // not logged in so redirect to login page with the return url
            this.router.navigate(['login'], { queryParams: { returnUrl: state.url }, queryParamsHandling: 'merge' });
            return false;
        }
    }
}
